import { AssignExamCourseButton } from '@exam-center/exam-center-exam-course-assignment';
import { MenuBookOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function NoExamCourseOverlay() {
  return (
    <NoRowsOverlay
      icon={MenuBookOutlinedIcon}
      title='ยังไม่มีหลักสูตรที่เปิดสอบ'
      description='คลิกปุ่มด้านล่างเพื่อเพิ่มหลักสูตร'
      action={<AssignExamCourseButton variant='outlined' size='large' />}
    />
  );
}
